<script>
    import _ from 'lodash'
    import uiInput from '../daniel/ui-input.vue';
    import {mapActions, mapGetters} from 'vuex'
    import swal from 'sweetalert'
    import mobiscroll from '@mobiscroll/javascript'

    let paymentForm = {
        cardholder: '',
        cardnumber: '',
        date: '',
        cvv: '',
        address: {
            line1: '',
            line2: '',
            line3: '',
            postal_code: '',
            state: '',
            city: '',
            country_code: "MX"
        }
    };

    export default {
	    components: { uiInput },
        name: 'cartPaymentMethods',
        data: () => {
            return {
                paymentForm: _.clone(paymentForm),
                deviceDataId: null,
                paymentIsSuccedded: false
            };
        },
        computed: {
            ...mapGetters(['OfertaGetCatalogo', 'cartGetAddress']),
            
            openpayObj() {
                try {
                    return {
                        card_number: this.paymentForm.cardnumber.replace(/[ ]/g, ""),
                        holder_name: this.paymentForm.cardholder,
                        expiration_month: this.paymentForm.date.replace(/\/\d+/g, ""),
                        expiration_year: this.paymentForm.date.replace(/\d+\//g, ""),
                        cvv2: this.paymentForm.cvv.toString(), 
                        // address: _.clone(this.cartGetAddress),
                    }
                } catch(e){
                    console.error(e)
                    mobiscroll.snackbar({
                        display: 'top',
                        theme: 'ios',
                        message: 'Ocurrió un error. Por favor verifica los campos de pago ' + e,
                        color: 'warning',
                        duration: 7000
                    })
                    return false
                }
            }
        },
        methods: {
            ...mapActions(['cartProcess']),
            async processCartCardPurchase() {
                return new Promise((success, fail) => {
                    if(!this.openpayObj){
                        fail('Parámetros inválidos.');
                    }
                    OpenPay.token.create(
                        this.openpayObj,
                        async (response) => {
                            if (response.status == 200 && await this.cartProcess({deviceDataId: this.deviceDataId, openpayId: response.data.id})) {
                                success('Finalizo');
                            } else {
                                fail('Error en la respuesta.');
                            }
                        },
                        (error) => {
                            swal({
                                icon: "warning",
                                title: "Hay un error en la captura de información de pago.",
                                text: error.data.description,
                            });
                            fail('Error de conexión');
                        }
                    );
                });
            },
        },
        mounted(){
            setTimeout(() => {
                this.deviceDataId = OpenPay.deviceData.setup( "#openpay-charge-form" );
            }, 100)
        }
    }
</script>

<template>
    <div id="cartPaymentMethods">
        <h5>Método de pago</h5>

        <b-form-group id="openpay-charge-form">

            <b-row>

                <b-col>
                    <ui-input v-model="paymentForm.cardholder" label="Nombre en mi tarjeta" />
                </b-col>

                <b-col>
                    <ui-input v-model="paymentForm.cardnumber" label="Número de tarjeta" type="card" />
                </b-col>

            </b-row>

            <b-row>

                <b-col>
                    <ui-input v-model="paymentForm.date" label="Fecha de vencimiento" type="card-vigency"/>
                </b-col>

                <b-col>
                    <ui-input class="cvv-input" v-model="paymentForm.cvv" label="CVV" type="card-cvv"/>
                </b-col>

            </b-row>

        </b-form-group>

        <div class="openpay-locator">
            <strong>Tu pago será procesado por</strong>
            <img src="public/images/openpay-color.77b290c.webp" alt="Openpay by BBVA" />
        </div>
    </div>
</template>